import * as React from 'react'
import { GUID, guidToString } from '../guids'
import { ToastsList } from '../types/types'

export interface Props {
  readonly toasts: ToastsList
  readonly removeToast: (id: GUID) => () => void
}

function Toasts({ toasts, removeToast }: Props): JSX.Element {
  return (
    <div className='toast-wrapper'>
      {toasts.map(t => (
        <div className='toast theme--base' key={guidToString(t.id)}>
          <button className='close-toast' onClick={removeToast(t.id)}>
            x
          </button>
          <p className='narrow-margins'>
            <b>{t.header}</b>
          </p>
          <p className='narrow-margins'>{t.content}</p>
        </div>
      ))}
    </div>
  )
}

export default Toasts
